import { reducer } from "ts-action";
import { on } from "ts-action-immer";
import * as AC from "./actionCreators";

type ImpersonatedUser = { id: number; userName: string };

export type State = {
  isFetching: boolean; // Probíhá akce na zjištění impersonizace?
  isSubmitting: boolean; // Probíhá akce na změnu impersonizace?
  isImpersonating: boolean | null; // null = ještě nevím, nedorazil první response
  impersonatedUser: null | ImpersonatedUser;
};

const initialState: State = {
  isFetching: false,
  isSubmitting: false,
  isImpersonating: null,
  impersonatedUser: null,
};

const impersonationReducer = reducer(
  initialState,
  // START IMPERSONATION
  on(AC.startImpersonationRequest, (state, action) => {
    state.isSubmitting = true;
  }),
  on(AC.startImpersonationSuccess, (state, action) => {
    const { userId } = action.payload;
    state.isSubmitting = false;
    state.isImpersonating = true;
    state.impersonatedUser = {
      id: userId,
      userName: "q:^)",
    };
  }),
  on(AC.startImpersonationError, (state, action) => {
    state.isSubmitting = false;
  }),

  // IS IMPERSONATING
  on(AC.isImpersonatingRequest, (state, action) => {
    state.isFetching = true;
  }),
  on(AC.isImpersonatingSuccess, (state, action) => {
    const { userId } = action.payload;
    const isImpersonating = userId !== 0;

    state.isFetching = false;
    state.isImpersonating = isImpersonating;

    if (!isImpersonating) {
      state.impersonatedUser = null;
      return;
    }

    state.impersonatedUser = {
      id: userId,
      userName: "q:^)",
    };
  }),
  on(AC.isImpersonatingError, (state, action) => {
    state.isFetching = false;
  }),

  // STOP IMPERSONATION
  on(AC.stopImpersonationRequest, (state, action) => {
    state.isSubmitting = true;
  }),
  on(AC.stopImpersonationSuccess, (state, action) => {
    state.isSubmitting = false;
    state.isImpersonating = false;
    state.impersonatedUser = null;
  }),
  on(AC.stopImpersonationError, (state, action) => {
    state.isSubmitting = false;
  })
);

export default impersonationReducer;
export type ImpersonationSlice = State;
